import styled, { css } from 'styled-components'
import { TextField } from '@material-ui/core'
import { GRAY_INFO, RED, MAIN_BACKGROUND } from 'constants/colors'
import { Flex } from 'components/common/styles'
import { StyledSelectInput } from 'components/common/Inputs/styles'
import { StyledName } from 'components/common/Modals/styles'

export const DaysContainer = styled(Flex)<{ error?: boolean }>`
  border: 1px solid ${GRAY_INFO};
  border-radius: 5px;
  margin-top: 10px;
  margin-bottom: 10px;
  ${({ error }) =>
    error &&
    css`
      border: 1px solid ${RED};
    `}
`

export const Day = styled(Flex)<{ noBorder?: boolean; selected?: boolean }>`
  padding: 5px 10px;
  border-right: ${({ noBorder }) => (noBorder ? 'none' : `solid ${GRAY_INFO}`)};
  border-width: 1px;
  width: 45px;
  cursor: pointer;
  ${({ selected }) =>
    selected &&
    css`
      background: ${MAIN_BACKGROUND};
      font-weight: bold;
    `}
  &:hover {
    background: ${MAIN_BACKGROUND};
  }
`

export const EveryTextField = styled(TextField)<{ error?: boolean }>`
  width: 54px;
  ${({ error }) =>
    error &&
    css`
      input {
        border: 1px solid ${RED} !important;
      }
    `}
`

export const OccurrencesTextField = styled(TextField)<{ error?: boolean }>`
  width: 45px;
  margin-right: 10px;
  margin-bottom: 8px;
  ${({ error }) =>
    error &&
    css`
      input {
        border: 1px solid ${RED} !important;
      }
    `}
`

export const RadioContainer = styled.div`
  margin: 10px 8px;
`

export const OccurrencesContainer = styled.div`
  margin-left: 10px;
  margin-top: 8px;
  margin-bottom: 8px;
`

export const StyledCondition = styled(Flex)<{ marginBottom?: number }>`
  ${({ marginBottom }) =>
    marginBottom &&
    css`
      margin-bottom: ${marginBottom}px;
    `}

  &:last-child {
    margin-bottom: 0;
  }

  .MuiTextField-root,
  ${StyledSelectInput} {
    + ${StyledName} {
      margin-left: 8px;
    }
  }
`

export const Wrapper = styled.div<{ displayDivider: boolean }>`
  margin-bottom: 8px;
  ${({ displayDivider }) =>
    displayDivider &&
    css`
      border-bottom: 1px solid ${GRAY_INFO};
      padding-bottom: 18px;
      margin-bottom: 18px;
    `}
`
